export default __webpack_public_path__ + "static/media/wow.53ef2a87.mp3";